import Vue from 'vue'
import SvgIcon from '@/components/svgIcon'// svg component
import myAutocomplete from "./myAutocomplete";//input含有搜索的功能
import magnify from "./magnify";

// register globally
Vue.component('svg-icon', SvgIcon)
Vue.component('my-autocomplete', myAutocomplete);
Vue.component('magnify', magnify);

const req = require.context('../assets/img/bottom', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
